import { AddMetadata, BlockKeys } from '../BlockCatalog';
import { BlockParameters, PipelineBlock } from '../PipelineBlock';
import InsidePolygonStage, { InsidePolygonStageParameters } from '../stages/filters/InsidePolygonStage';

export interface InsidePolygonParameters extends BlockParameters, InsidePolygonStageParameters {}

@AddMetadata({ type: BlockKeys.InsidePolygon, name: 'Slice Polygon', description: 'Keeps the Sensor Points inside the drawn polygon' })
class InsidePolygonBlock extends PipelineBlock<InsidePolygonParameters> {
    constructor(params?: InsidePolygonParameters, id?: string) {
        super({ polygon: [], invert: false, ...params }, id);
    }

    protected override defineStages() {
        return [new InsidePolygonStage(this.getParams())];
    }
}

export default InsidePolygonBlock;
